import React from "react";
import Marquee from "react-fast-marquee";
import { TrendUp, TrendDown } from "@phosphor-icons/react";
import { useGlobalData } from "@/lib/dataStreams";

export default function ArbitrageTicker() {
  const { ticker: items } = useGlobalData();

  if (!items.length) return null;

  items.forEach(t => {
      if (!t.id) t.id = t.buy_ex + t.sell_ex + t.pnl_usd + Math.random().toString(36).substring(7);
  });

  return (
    <div className="border-y border-slate-800 bg-slate-900/30 py-2.5" data-testid="arbitrage-ticker">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {items.map((t, i) => {
          const pos = t.pnl_usd >= 0;
          return (
            <div key={t.id} className="flex items-center gap-3 mx-6 font-mono text-xs font-medium whitespace-nowrap">
              <span className="text-slate-400">{t.buy_ex}</span>
              <span className="text-indigo-400">→</span>
              <span className="text-slate-400">{t.sell_ex}</span>
              <span className="text-slate-200">{t.pair}</span>
              <span className={pos ? "text-emerald-400 bg-emerald-400/10 px-1.5 py-0.5 rounded" : "text-rose-400 bg-rose-400/10 px-1.5 py-0.5 rounded"}>
                {pos ? <TrendUp size={12} className="inline mr-1" /> : <TrendDown size={12} className="inline mr-1" />}
                +{t.spread_pct}%
              </span>
              <span className="text-slate-300">Est: <span className="text-emerald-400">${t.pnl_usd}</span></span>
              <span className="text-slate-700 mx-2">|</span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
